import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

const ProtectedRoute = ({ children }) => {
  const [state, setState] = useState({ status: "checking", user: null });
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const me = await api.me();
        if (!me?.is_admin) throw new Error("not admin");
        setState({ status: "ok", user: me });
      } catch {
        setState({ status: "unauth", user: null });
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate]);

  if (state.status === "checking") {
    return (
      <div className="min-h-screen bg-paper flex items-center justify-center" data-testid="admin-checking">
        <div className="text-center">
          <div className="overline overline-muted mb-4">Loading Console</div>
          <div className="preload-bar w-56 mx-auto" />
        </div>
      </div>
    );
  }
  if (state.status !== "ok") return null;
  return React.cloneElement(children, { user: state.user });
};

export default ProtectedRoute;
